module.exports = __webpack_public_path__ + "static/img/print-6.3d40604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/print-6.png
// module id = Z9DK
// module chunks = 10